import CustomerServiceTiles from "@/components/CustomerServiceTiles.vue";

export const customerServiceTilesInit = {
    component: CustomerServiceTiles,
    name: "Customer Service Tiles",
    inputs: [
        {
            name: 'tiles',
            friendlyName: 'Tiles',
            type: 'array',
            subFields: [
                {
                    name: 'title',
                    friendlyName: 'Title',
                    type: 'string',
                    defaultValue: 'Live Chat'
                },
                {
                    name: 'details',
                    friendlyName: 'Details',
                    type: 'array',
                    subFields: [
                        {
                            name: 'text',
                            friendlyName: 'Text',
                            type: "richText",
                            defaultValue: 'This is the fastest way to reach us, anytime 24/7.'
                        }
                    ]
                },
                {
                    name: 'isLiveChat',
                    friendlyName: 'Is Live Chat',
                    type: 'boolean',
                    defaultValue: true
                }
            ]
        }
    ]
}